<template lang="pug">
.lk-notifications
	.lk-notifications__container
		v-loader(:loading="loading")
		component.lk-notifications__title.h1(v-if="data && data.title" :is="data.titleLevel || 'h1'") {{data?.title}}
		.lk-notifications__content
			.lk-notifications__row(v-for="({prefixId = 'ID', time, text, className}, index) in data?.items" :class="className" key="index")
				.lk-notifications__row-time(v-if="time") {{time}}
				.lk-notifications__row-text(v-if="text") {{text}}
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';

	export default {
		mixins: [
			sourceMixin,
		],

		data() {
			return {
				data: null
			}
		},

		methods: {
			dataSet(data) {
				this.data = data;
			}
		}
	}
</script>
